// src/features/dashboard/components/ui/Skeleton.tsx
import clsx from 'clsx';

interface SkeletonProps {
  className?: string;
  rounded?: 'sm' | 'md' | 'lg' | 'full';
}

const roundedMap: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  sm: 'rounded-md',
  md: 'rounded-lg',
  lg: 'rounded-2xl',
  full: 'rounded-full',
};

export function Skeleton({ className, rounded = 'md' }: SkeletonProps) {
  return <div className={clsx('vania-skeleton', roundedMap[rounded], className)} />;
}

export function StatCardSkeleton() {
  return (
    <div className="vania-glass-card p-5 sm:p-6 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-11 w-11" rounded="lg" />
        <Skeleton className="h-5 w-14" rounded="full" />
      </div>
      <Skeleton className="h-7 w-2/3" />
      <Skeleton className="h-3.5 w-1/2" />
    </div>
  );
}

export function ChartCardSkeleton() {
  return (
    <div className="vania-glass-card p-5 sm:p-6 flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-5 w-20" rounded="full" />
      </div>
      <Skeleton className="h-56 w-full" rounded="lg" />
    </div>
  );
}

export function TableRowSkeleton() {
  return (
    <div className="flex items-center gap-4 px-5 py-3.5">
      <Skeleton className="h-9 w-9" rounded="full" />
      <Skeleton className="h-3.5 flex-1" />
      <Skeleton className="h-3.5 w-20" />
      <Skeleton className="h-5 w-16" rounded="full" />
    </div>
  );
}

export function ListItemSkeleton() {
  return (
    <div className="flex items-center gap-3 py-3">
      <Skeleton className="h-9 w-9" rounded="full" />
      <div className="flex-1 flex flex-col gap-2">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
      </div>
    </div>
  );
}
